import React from "react";

const LeftArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-6"
    >
      <path
        d="M16.875 10H3.125"
        stroke="#1E4387"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 4.375L3.125 10L8.75 15.625"
        stroke="#1E4387"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LeftArrow;
